import { UserProfilePopulatedEntity } from '@smatchy/sdk';
import { GeoLocality } from '../../locations/domains/geo-locality';
import { GeoPosition } from '../../locations/domains/geo-position';

export const PROFILE_HOME_LOCATION_KEY = 'profileHomeLocationSnapshot';

export interface ProfileHomeLocationSnapshot {
  locality: Partial<GeoLocality>;
  position: GeoPosition;
}

export function persistProfileHomeLocationSnapshot(
  snapshot: ProfileHomeLocationSnapshot,
): void {
  if (
    !snapshot.position?.lat ||
    !snapshot.position?.lng ||
    !snapshot.locality?.city
  ) {
    return;
  }

  localStorage.setItem(PROFILE_HOME_LOCATION_KEY, JSON.stringify(snapshot));
}

export function readProfileHomeLocationSnapshot():
  | ProfileHomeLocationSnapshot
  | undefined {
  const rawSnapshot = localStorage.getItem(PROFILE_HOME_LOCATION_KEY);

  if (!rawSnapshot) {
    return undefined;
  }

  try {
    const snapshot = JSON.parse(rawSnapshot) as ProfileHomeLocationSnapshot;

    if (
      !snapshot?.position?.lat ||
      !snapshot?.position?.lng ||
      !snapshot?.locality?.city
    ) {
      return undefined;
    }

    return snapshot;
  } catch {
    return undefined;
  }
}

export function clearProfileHomeLocationSnapshot(): void {
  localStorage.removeItem(PROFILE_HOME_LOCATION_KEY);
}

export function seedProfileHomeLocationSnapshotIfMissing(
  profile?: UserProfilePopulatedEntity,
): void {
  if (readProfileHomeLocationSnapshot()) {
    return;
  }

  if (
    !profile?.city ||
    !profile.location?.lat ||
    !profile.location?.lon
  ) {
    return;
  }

  persistProfileHomeLocationSnapshot({
    locality: {
      city: profile.city,
      country: profile.country,
      formattedAddress:
        profile.location.name ||
        [profile.city, profile.country].filter(Boolean).join(', '),
      placeId: profile.location.placeId,
      hierarchy: profile.location.hierarchy,
    },
    position: {
      lat: profile.location.lat,
      lng: profile.location.lon,
    },
  });
}
